function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from 'react';
import { Center, Box } from '@tapresearch/ui/components';
export var QuestionNumber = function(param) {
    var num = param.num, _param_boxStyles = param.boxStyles, boxStyles = _param_boxStyles === void 0 ? {} : _param_boxStyles, _param_textStyles = param.textStyles, textStyles = _param_textStyles === void 0 ? {} : _param_textStyles;
    return /*#__PURE__*/ React.createElement(Center, _object_spread({}, QuestionNumStyles, boxStyles), /*#__PURE__*/ React.createElement(Box, _object_spread({
        as: "span",
        fontSize: 'md',
        fontWeight: 'bold',
        color: 'gray.800'
    }, textStyles), num));
};
var QuestionNumStyles = {
    variant: 'square',
    rounded: 'md',
    mr: 4,
    w: '28px',
    h: '28px',
    bg: 'blue.100'
};
